<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <Loader v-if="isLoading" />
    <div v-else>
      <Navbar v-if="!isDashboardRoute && !isAuthRoute" />
      <router-view></router-view>
      <Footer v-if="!isDashboardRoute && !isAuthRoute" />
    </div>
  </div>
</template>


<script>
import Navbar from "./Website/SharedUI/Navbar.vue";
import Footer from "./Website/SharedUI/Footer.vue";
import Loader from "./Loader.vue";

export default {
  components: {
    Navbar,
    Footer,
    Loader,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
    },
  },
  computed: {
    isDashboardRoute() {
      return this.$route.path.startsWith("/admin");
    },
    isAuthRoute() {
      return (
        this.$route.path.startsWith("/login") ||
        this.$route.path.startsWith("/forget-password") ||
        this.$route.path.startsWith("/resetpassword")
      );
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/light-bootstrap-dashboard.scss";


.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
  .authStyle{
    padding-top: 300px !important;
  }
}
</style>
